import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { LanguageService } from '../language/language.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly languageService = inject(LanguageService);
  private readonly oauthService = inject(OAuthService);

  public hasValidAccessToken(): boolean {
    return this.oauthService.hasValidAccessToken();
  }

  public logout(): void {
    this.oauthService.logOut({
      lang: this.languageService.getCurentLanguage(),
    });
  }
}
